export default "__VITE_ASSET__aead84bd__"